'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_RequestedFilename$package$RequestedFilename$() {
  this.aFP = null;
  this.aFQ = false;
  this.LU = null;
  $n_Lapp_data_RequestedFilename$package$RequestedFilename$ = this;
  var e$proxy1 = this.iu("clientReq");
  matchResult1: {
    var $x_1;
    if ((e$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy1.bj) + ")"));
    }
    if ((e$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
      var $x_1 = e$proxy1.aI;
      break matchResult1;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy1);
  }
  this.LU = $x_1;
}
export { $c_Lapp_data_RequestedFilename$package$RequestedFilename$ as $c_Lapp_data_RequestedFilename$package$RequestedFilename$ };
$p = $c_Lapp_data_RequestedFilename$package$RequestedFilename$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_RequestedFilename$package$RequestedFilename$;
/** @constructor */
function $h_Lapp_data_RequestedFilename$package$RequestedFilename$() {
}
export { $h_Lapp_data_RequestedFilename$package$RequestedFilename$ as $h_Lapp_data_RequestedFilename$package$RequestedFilename$ };
$h_Lapp_data_RequestedFilename$package$RequestedFilename$.prototype = $p;
$p.fI = (function() {
  if ((!this.aFQ)) {
    this.aFP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__tapirCodec__Lsttp_tapir_Codec(this);
    this.aFQ = true;
  }
  return this.aFP;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_RequestedFilename$package$RequestedFilename$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_RequestedFilename$package$RequestedFilename$, "app.data.RequestedFilename$package$RequestedFilename$", ({
  F1: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_RequestedFilename$package$RequestedFilename$ as $d_Lapp_data_RequestedFilename$package$RequestedFilename$ };
var $n_Lapp_data_RequestedFilename$package$RequestedFilename$;
function $m_Lapp_data_RequestedFilename$package$RequestedFilename$() {
  if ((!$n_Lapp_data_RequestedFilename$package$RequestedFilename$)) {
    $n_Lapp_data_RequestedFilename$package$RequestedFilename$ = new $c_Lapp_data_RequestedFilename$package$RequestedFilename$();
  }
  return $n_Lapp_data_RequestedFilename$package$RequestedFilename$;
}
export { $m_Lapp_data_RequestedFilename$package$RequestedFilename$ as $m_Lapp_data_RequestedFilename$package$RequestedFilename$ };
//# sourceMappingURL=app.data.-Requested-Filename$package$-Requested-Filename$.js.map
